// extracted by mini-css-extract-plugin
module.exports = {"cartUrgencyText":"CartUrgencyBar_cartUrgencyText__pgUuu","leftToRight":"CartUrgencyBar_leftToRight___h_Wf"};